(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist-sign/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist-sign/build/pdf"] = factory();
	else
		root["pdfjs-dist-sign/build/pdf"] = factory();
})(this, function() {
return 